import { createStrictOptionalContext } from 'helpers/context';
import { PropsWithChildren, ReactElement, useMemo } from 'react';
import {
  DisplayedFile,
  DisplayedFilesStore,
} from '../../common/gallery/filesStore';

interface DisplayedFilesContextType<K = object> {
  filesStore: DisplayedFilesStore<K>;
  useDisplayedFiles: <T>(
    selector: (files: DisplayedFile<K>[]) => T
  ) => [T, (value: DisplayedFile<K>[]) => void];
  downloadFile: (file: DisplayedFile<K>) => void;
}
const {
  Provider: DisplayedFilesProvider,
  useRequiredContext: useAnyDisplayedFilesContext,
} = createStrictOptionalContext<DisplayedFilesContextType<any>>(
  'useDisplayedFilesContext',
  'WithDisplayedFiles'
);

export function WithDisplayedFiles<K>({
  filesStore,
  useDisplayedFiles,
  downloadFile,
  children,
}: PropsWithChildren<DisplayedFilesContextType<K>>): ReactElement {
  const ctx = useMemo(() => {
    return { filesStore, useDisplayedFiles, downloadFile };
  }, [filesStore, useDisplayedFiles, downloadFile]);

  return (
    <DisplayedFilesProvider value={ctx}>
      {children}
    </DisplayedFilesProvider>
  );
}

export function useDisplayedFilesContext<
  K = object,
>(): DisplayedFilesContextType<K> {
  return useAnyDisplayedFilesContext();
}
